export function getHoleStyles(index, maxHole) {
  let color = "#FFFFFF";
  let background = "#2D083F";

  // if number of holes is divisible by 4
  if (maxHole === 20) {
    color =
      (index + 1) % 4 === 1
        ? "#FFFFFF"
        : (index + 1) % 4 === 2
        ? "#2D083F"
        : (index + 1) % 4 === 3
        ? "#FFFFFF"
        : "#2D083F";

    background =
      (index + 1) % 4 === 1
        ? "#C00000"
        : (index + 1) % 4 === 2
        ? "#FFFFFF"
        : (index + 1) % 4 === 3
        ? "#0C47C9"
        : "#FFA500";
  }
  // else if (maxHole % 5 === 0) {
  //   color =
  //     (index + 1) % 5 === 1
  //       ? "#000000"
  //       : (index + 1) % 5 === 2
  //       ? "#FFFFFF"
  //       : (index + 1) % 5 === 3
  //       ? "#2D083F"
  //       : (index + 1) % 5 === 4
  //       ? "#FFFFFF"
  //       : "#000000";

  //   background =
  //     (index + 1) % 5 === 1
  //       ? "#89F336"
  //       : (index + 1) % 5 === 2
  //       ? "#C00000"
  //       : (index + 1) % 5 === 3
  //       ? "#FFFFFF"
  //       : (index + 1) % 5 === 4
  //       ? "#0C47C9"
  //       : "#FFA500";
  // }
  else {
    color = "#2D083F";
    background = "#ffffff";
  }

  return { color, background };
}
